import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class CommunitySnapshot extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "year", Model.attribute('year'));
    _defineProperty(this, "snapshotData", Model.attribute('data'));
    _defineProperty(this, "generatedAt", Model.attribute('generatedAt', Model.transformDate));
  }
}
flarum.reg.add('huseyinfiliz-rewind', 'common/models/CommunitySnapshot', CommunitySnapshot);